import validate from './validate';
import { Rules } from '.';

export default function createValidator<T>(rules: Rules<T>) {
  return (values: RecursivePartial<T>) => validate(rules, values);
}



// WEBPACK FOOTER //
// ./src/helpers/validation/createValidator.ts